import { Component } from "@angular/core";
import { EventService, Announcement } from "src/app/providers/event.service";

import { BvAlertComponent } from "../../design-system/primitives/alert.component";
import { BvIconComponent } from "../../design-system/primitives/icon.component";
import { TranslateModule } from "@ngx-translate/core";

const DISMISS_STORAGE_KEY = "bv:announcement:dismissed";

@Component({
    selector: "app-announcement",
    templateUrl: "./announcement.component.html",
    styleUrls: ["./announcement.component.css"],
    imports: [BvAlertComponent, BvIconComponent, TranslateModule]
})
export class AnnouncementComponent {
  constructor(public eventServ: EventService) {}

  get visible(): boolean {
    const a = this.eventServ.announcement;
    if (!a || !a.text || !a.url || !a.ctaText) return false;
    return this.readDismissed() !== this.keyFor(a);
  }

  dismiss(): void {
    const a = this.eventServ.announcement;
    if (!a) return;
    try {
      localStorage.setItem(DISMISS_STORAGE_KEY, this.keyFor(a));
    } catch {
      /* localStorage unavailable (private mode) — no-op */
    }
  }

  private keyFor(a: Announcement): string {
    return `${a.text}|${a.url}|${a.ctaText}`;
  }

  private readDismissed(): string | null {
    try {
      return localStorage.getItem(DISMISS_STORAGE_KEY);
    } catch {
      return null;
    }
  }
}
